export { default as UploadFile } from "./upload-file.vue";
export * from "./IUploadFile";